import React, { ReactElement } from "react";
import { FormFieldType } from "../../../__generated__/api";
import Select from "../../select/Select";

const CHOICE_LABELS = ["Group", "Options"];

export const CUSTOM_FIELD_PROPS = {

    [FormFieldType.Text]: {
        text: "Text",
        canCreate: true,
        canEnterChoice: false,
        childLevels: 0,
        labels: [],
    },

    [FormFieldType.Password]: {
        text: "Password",
        canCreate: true,
        canEnterChoice: false,
        childLevels: 0,
        labels: [],
    },

    [FormFieldType.LongText]: {
        text: "Long Text",
        canCreate: true,
        canEnterChoice: false,
        childLevels: 0,
        labels: [],
    },

    [FormFieldType.Number]: {
        text: "Number",
        canCreate: true,
        canEnterChoice: false,
        childLevels: 0,
        labels: [],
    },
    [FormFieldType.Decimal]: {
        text: "Decimal",
        canCreate: true,
        canEnterChoice: false,
        childLevels: 0,
        labels: [],
    },

    [FormFieldType.Boolean]: {
        text: "Yes/No",
        canCreate: true,
        canEnterChoice: false,
        childLevels: 0,
        labels: [],
    },

    [FormFieldType.Date]: {
        text: "Date",
        canCreate: true,
        canEnterChoice: false,
        childLevels: 0,
        labels: [],
    },

    [FormFieldType.Time]: {
        text: "Time",
        canCreate: true,
        canEnterChoice: false,
        childLevels: 0,
        labels: [],
    },

    [FormFieldType.DateTime]: {
        text: "Date and Time",
        canCreate: true,
        canEnterChoice: false,
        childLevels: 0,
        labels: [],
    },

    [FormFieldType.AsyncDropdown]: {
        text: "Choice",
        canCreate: false,
        canEnterChoice: false,
        childLevels: 1,
        labels: CHOICE_LABELS,
    },
    [FormFieldType.MultiLevelDropdown]: {
        text: "Multi-level Choice",
        canCreate: true,
        canEnterChoice: true,
        childLevels: -1,
        labels: undefined,
    },
    [FormFieldType.MultiSelectDropdown]: {
        text: "Multiple Choice",
        canCreate: true,
        canEnterChoice: true,
        childLevels: 2,
        labels: CHOICE_LABELS,
    },
    [FormFieldType.Dropdown]: {
        text: "Choice",
        canCreate: true,
        canEnterChoice: true,
        childLevels: 2,
        labels: CHOICE_LABELS,
    },
    [FormFieldType.Checkboxes]: {
        text: "Checkboxes",
        canCreate: true,
        canEnterChoice: true,
        childLevels: 1,
        labels: [],
    },

    [FormFieldType.SearchText]: {
        text: "Search Text",
        canCreate: false,
        canEnterChoice: false,
        childLevels: 0,
        labels: [],
    },

    [FormFieldType.User]: {
        text: "User",
        canCreate: true,
        canEnterChoice: false,
        childLevels: 0,
        labels: [],
    },
    [FormFieldType.Users]: {
        text: "Users",
        canCreate: true,
        canEnterChoice: false,
        childLevels: 0,
        labels: [],
    },
};

const FIELDS = Object.entries(CUSTOM_FIELD_PROPS).filter(([, row]) => row.canCreate).map(([value, row]) => ({
    label: row.text,
    value,
}));

export default function FieldType({
    onChange, value, className, allowedTypes,
}: {
    onChange: (value: FormFieldType) => void;
    value: FormFieldType;
    className?: string;
    allowedTypes?: FormFieldType[];
}): ReactElement {
    let fields = FIELDS;
    if (allowedTypes) {
        const types = new Set(allowedTypes);
        fields = fields.filter(row => types.has(row.value as FormFieldType));
    }
    return (
        <Select
            className={className}
            placeholder=""
            onChange={selected => onChange(selected.value as FormFieldType)}
            options={fields}
            value={FIELDS.find(option => option.value === value)}
        />
    );
}

FieldType.defaultProps = {
    className: "",
    allowedTypes: undefined,
};
